<template>
  <div
    :class="[
      ns.b(),
      ns.is('disabled', disabled),
      ns.is('favorite', favorite),
    ]"
    :style="{ '--enter-delay': `${enterDelay}ms` }"
    role="button"
    :tabindex="disabled ? -1 : 0"
    :aria-disabled="disabled"
    @click="handleClick"
    @keydown="handleKeydown"
  >
    <span :class="ns.e('icon')" :data-tone="tone % 4">
      <slot name="icon" />
    </span>
    <div :class="ns.e('body')">
      <span :class="ns.e('label')">{{ label }}</span>
      <span :class="ns.e('enter')">{{ enterText }}</span>
    </div>
    <button
      v-if="showFavorite && !disabled"
      type="button"
      :class="[ns.e('star'), ns.is('active', favorite)]"
      :aria-label="favorite ? '取消收藏' : '收藏'"
      @click.stop="emit('favorite', !favorite)"
    >
      <z-icon>
        <star-filled v-if="favorite" />
        <star v-else />
      </z-icon>
    </button>
  </div>
</template>

<script lang="ts" setup>
import { Star, StarFilled } from '@zoryn/icons'
import { useNamespace } from '@zoryn/hooks'
import ZIcon from '@zoryn/components/icon'
import type { DashboardCardProps } from './dashboard'

defineOptions({
  name: 'ZDashboardCard',
})

const props = withDefaults(defineProps<DashboardCardProps>(), {
  favorite: false,
  disabled: false,
  tone: 0,
  enterDelay: 0,
  showFavorite: true,
  enterText: '进入',
})

const emit = defineEmits<{
  click: []
  favorite: [next: boolean]
}>()

const ns = useNamespace('dashboard-card')

function handleClick() {
  if (props.disabled) return
  emit('click')
}

function handleKeydown(event: KeyboardEvent) {
  if (props.disabled) return
  if (event.key === 'Enter' || event.key === ' ') {
    event.preventDefault()
    handleClick()
  }
}
</script>
